import { VariablesService } from '@services/variables/variables.service';
import { StorageService } from '@services/storage/storage.service';
import { inject, Component, ViewChild, ElementRef, Renderer2, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { EventsService } from '@services/events/events.service';
import { UtilService } from '@services/util/util.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonTalktousModalComponent } from '@common-components/common-talktous-modal/common-talktous-modal.component';
import { SignupService } from '@services/signup/signup.service';
import { Router } from '@angular/router';
import { InViewportModule } from 'ng-in-viewport';
import { StartfundraiserButtonComponent } from '@common-components/startfundraiser-button/startfundraiser-button.component';
@Component({
  selector: 'app-sacflow-v2',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    InViewportModule,
    StartfundraiserButtonComponent
  ],
  templateUrl: './sacflow-v2.component.html',
  styleUrls: ['./sacflow-v2.component.scss']
})
export class SacflowComponentV2 {

  public dialog = inject(MatDialog);
  public util = inject(UtilService);
  public events = inject(EventsService);
  private signupService = inject(SignupService);
  private storage = inject(StorageService);
  private renderer = inject(Renderer2);
  readonly vars = inject(VariablesService);
  public router = inject(Router);

  @Input() title: string;
  @Input() mobileTitle: string;
  @Input() showMWebMobile: boolean = false;
  @Input() steps = [
    {
      icon: '/assets/images/home-v2/volunteer.png',
      title: 'Start your fundraiser',
      desc: `It'll take only 2 minutes. Just tell us a few details about you and the ones you are raising funds for.`
    },
    {
      icon: '/assets/images/home-v2/share_reviews.png',
      title: 'Share your fundraiser',
      desc: 'All you need to do is share the fundraiser with your friends and family. In no time, support will start pouring in.'
    },
    {
      icon: '/assets/images/home-v2/monetization.png',
      title: 'Withdraw Funds',
      desc: 'The funds raised can be withdrawn without any hassle directly to your bank account.'
    }
  ];

  @ViewChild('videoPlayer') videoplayer: ElementRef;
  public imgLoader = true;
  isMobile = this.vars.isMobile;


  playVideo(event) {
    if (this.vars.isBrowser) {
      const videoPlay = this.videoplayer.nativeElement;
      this.renderer.setStyle(videoPlay, 'display', 'none');
      videoPlay.muted = true;
      if (event.visible === true) {
        this.imgLoader = false;
        videoPlay.play();
        this.renderer.setStyle(videoPlay, 'display', 'block');
      } else {
        videoPlay.pause();
        this.renderer.setStyle(videoPlay, 'display', 'block');
      }
    } else if (event.visible === true) {
      this.imgLoader = true;
    }
  }

  /*Event for start a fundraiser body button */
  pushBodyButton(url) {
    const payload = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.vars.pageName || 'home',
      info_1: 'type',
      info_2: this.vars.pageName === 'crowdfunding' ? 'home_5' : 'home_2'
    };
    const full_url = `${this.vars.domainData.url}/${url}`;
    this.events.sendSystemEvent(payload).subscribe(() => { });
    this.storage.checkFromSession('sac-initiated', payload);
    this.vars.loginType = 'signup';
    this.signupService.startFR(full_url);
  }

  openDialogTalkToUs() {
    const payload = {
      eventName: 'talk_to_us',
      event_type: 'campaign',
      page_name: this.vars.pageName || 'home',
      info_1: 'type',
      info_2: 'home_1',
    };
    this.events.sendSystemEvent(payload).subscribe(() => { });
    this.dialog.open(CommonTalktousModalComponent, {
      maxWidth: '100vw',
      width: '519px',
      panelClass: 'talk-to-us-modal'
    });
  }

  routeTo(url): void {
    this.router.navigate([url]);
    const payload = {
      eventName: 'medical_cost_calculator',
      event_type: 'campaign',
      info_1: 'step',
      info_2: '1',
      page_name: this.vars.pageName || 'home'
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }

}
